import { render, staticRenderFns } from "./ChangeAddress.vue?vue&type=template&id=9c977a9c&scoped=true"
import script from "./ChangeAddress.vue?vue&type=script&lang=ts"
export * from "./ChangeAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c977a9c",
  null
  
)

export default component.exports